<template>
  <div class="login-overlay" @click.self="onCancel">
    <div class="login-card">

      <div class="login-header">
        <h2>{{ title }}</h2>
        <button class="close-btn" @click="onCancel">&#10005;</button>
      </div>

      <div class="form">
        <p class="confirm-message">{{ message }}</p>

        <button class="danger-btn" :disabled="busy" @click="$emit('confirm')">
          {{ confirmLabel || t('confirm') }}
        </button>
        <button class="secondary-btn" :disabled="busy" @click="onCancel">
          {{ t('cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "../i18n.js"

export default {
  name: "ConfirmDialog",

  props: {
    title: { type: String, required: true },
    message: { type: String, required: true },
    confirmLabel: { type: String, default: "" },
    busy: { type: Boolean, default: false }
  },

  emits: ["confirm", "cancel"],

  setup() {
    const { t } = useI18n()
    return { t }
  },

  mounted() {
    window.addEventListener("keydown", this.onKeydown)
  },

  beforeUnmount() {
    window.removeEventListener("keydown", this.onKeydown)
  },

  methods: {
    onKeydown(e) {
      if (e.key === "Escape") this.onCancel()
    },
    onCancel() {
      if (this.busy) return
      this.$emit("cancel")
    }
  }
}
</script>

<style scoped>
.login-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 130;
}

.login-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.login-header h2 { margin: 0; font-size: 18px; }

.close-btn {
  border: none;
  background: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
}
.close-btn:hover { color: #000; }

.login-card {
  width: min(420px, calc(100vw - 32px));
  background: white;
  padding: 24px;
  border-radius: 12px;
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.confirm-message {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #374151;
}

button {
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  cursor: pointer;
}
button:disabled { cursor: not-allowed; opacity: 0.7; }

.danger-btn {
  background: #dc2626;
  color: #fff;
}
.danger-btn:hover:not(:disabled) { background: #b91c1c; }

.secondary-btn {
  background: #f0f2f5;
  color: #1a1a2e;
}
.secondary-btn:hover:not(:disabled) { background: #e4e8ee; }
</style>
